import { render, staticRenderFns } from "./JournalPhotos.vue?vue&type=template&id=571ebf25&"
import script from "./JournalPhotos.vue?vue&type=script&lang=js&"
export * from "./JournalPhotos.vue?vue&type=script&lang=js&"
import style0 from "./JournalPhotos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports